import { FunctionComponent } from 'react'
import { ModuleI } from '@lib/contentful/entries'
import Module, {
  AllowedThemes,
  ModuleContainer,
  ModuleHeadline,
  ModuleSubheadline,
  themesMap,
} from '@components/undock/modules'
import {
  CardDescription,
  CardLabel,
  CardPrice,
  CardPriceLabel,
  CardsWrapper,
  ContentWrapper,
  CtaWrapper,
  ListItem,
  ListItems,
} from '@components/undock/modules/pricing/style'
import Card from '@components/undock/cards'
import { gold } from '@lib/colors'
import { ThemeProvider } from '@emotion/react'
import SignupButton from '@components/undock/ctas/signup'
import { PrimaryLink, SecondaryLink } from '@components/undock/buttons'

interface PricingModulePropsI extends ModuleI {}

const PricingModule: FunctionComponent<PricingModulePropsI> = ({
  headline = null,
  id = 'NO_ID_PROVIDED',
  subHeadline = null,
  themeName = 'light',
}) => {
  return (
    <Module id={id} theme={themesMap[themeName]}>
      <ModuleContainer>
        <ContentWrapper>
          {headline && <ModuleHeadline>{headline}</ModuleHeadline>}
          {subHeadline && <ModuleSubheadline>{subHeadline}</ModuleSubheadline>}
        </ContentWrapper>
        <CardsWrapper>
          <ThemeProvider theme={themesMap.light}>
            <Card>
              <CardLabel>Base</CardLabel>
              <CardPrice>Free</CardPrice>
              <CardDescription>
                Ideal for light personal and business use
              </CardDescription>
              <ListItems>
                <ListItem>Connect 4 Calendars</ListItem>
                <ListItem>6 Scheduling Pages</ListItem>
                <ListItem>Create 10 Plans</ListItem>
                <ListItem>50 Outbound Requests/mo</ListItem>
                <ListItem>50 Hours Video Conferencing</ListItem>
                <ListItem>Collect 15 Payments/mo</ListItem>
              </ListItems>
              <CtaWrapper>
                <SignupButton />
              </CtaWrapper>
            </Card>
          </ThemeProvider>
          <ThemeProvider theme={themesMap.dark}>
            <Card>
              <CardLabel>Premium</CardLabel>
              <CardPrice>
                $10
                <CardPriceLabel>/month</CardPriceLabel>
              </CardPrice>
              <CardDescription>
                Take command of your calendar
              </CardDescription>
              <ListItems>
                <ListItem>Everything in Base</ListItem>
                <ListItem>Unlimited Calendars</ListItem>
                <ListItem>Unlimited Scheduling Pages</ListItem>
                <ListItem>Create 30 Plans</ListItem>
                <ListItem>100 Outbound Requests/mo</ListItem>
                <ListItem>150 Hours Video Conferencing</ListItem>
                <ListItem>People & Time Analytics</ListItem>
                <ListItem>Collect 30 Payments/mo</ListItem>
              </ListItems>
              <CtaWrapper>
                <PrimaryLink href="https://undock.com/settings/membership?upgrade=true">Get started</PrimaryLink>
              </CtaWrapper>
            </Card>
          </ThemeProvider>
          <ThemeProvider theme={themesMap.light}>
            <Card borderColor={gold}>
              <CardLabel color={gold}>Unlimited</CardLabel>
              <CardPrice>
                $20
                <CardPriceLabel>/month</CardPriceLabel>
              </CardPrice>
              <CardDescription>
                Unlock the most powerful calendar in the galaxy
              </CardDescription>
              <ListItems>
                <ListItem>Everything in Premium</ListItem>
                <ListItem>Unlimited Plans</ListItem>
                <ListItem>Unlimited Events</ListItem>
                <ListItem>Unlimited Video Conferencing</ListItem>
                <ListItem>Unlimited Payments</ListItem>
              </ListItems>
              <CtaWrapper>
                <SecondaryLink href="https://undock.com/settings/membership?upgrade=true">Get started</SecondaryLink>
              </CtaWrapper>
            </Card>
          </ThemeProvider>
        </CardsWrapper>
      </ModuleContainer>
    </Module>
  )
}

export default PricingModule
